export default __webpack_public_path__ + "static/media/Metropolis-Bold.4a0d96b8.woff";